import { PostEntity } from '@/swagger/funwoo.api';

export const SUB_CATEGORIES = [
  {
    key: '',
    label: '所有文章',
  },
  {
    key: '執行長觀點',
    label: '執行長觀點',
  },
  {
    key: '置產小學堂',
    label: '置產小學堂',
  },
  {
    key: '美國升學護照',
    label: '美國升學護照',
  },
  {
    key: '政策新聞',
    label: '政策新聞',
  },
  {
    key: '探索美國城市',
    label: '探索美國城市',
  },
];

export type ArticleBody =
  // H1, H2, H3
  | {
      type: 'h1';
      content: Array<string>;
    }
  | {
      type: 'h2';
      content: Array<string>;
    }
  | {
      type: 'h3';
      content: Array<string>;
    }
  | {
      type: 'h4';
      content: Array<string>;
    }
  // Body
  | {
      type: 'body';
      content: Array<string>;
      hypertext?: Array<{
        keyword: string;
        href: string;
      }>;
      highlight?: Array<{
        keyword: string;
      }>;
    }
  // Image
  | {
      type: 'image';
      content: Array<{
        src: string;
        alt: string;
        orientation?: 'horizontal' | 'vertical';
      }>;
    }
  // Video
  | {
      type: 'video';
      content: Array<{
        src: 'youtube';
        id: string;
      }>;
    }
  // Divider
  | {
      type: 'divider';
    }
  // Hyperlink
  | {
      type: 'hyperlink';
      content: Array<{
        title: string;
        href: string;
      }>;
    }
  // List
  | {
      type: 'list-decimal';
      content: Array<string>;
    }
  | {
      type: 'list-dot';
      content: Array<string>;
    }
  // Table
  | {
      type: 'table';
      content: {
        header: Array<string>;
        body: Array<{ row: Array<string> }>;
      };
      columnConfig?: Array<{ width: number }>;
    };

// The utility type `GetArticleBodyByType` is used to get the type of `ArticleBody` by the value of `ArticleBody['type']`.
export type GetArticleBodyByType<Type = ArticleBody['type']> = Type extends ArticleBody['type']
  ? Omit<
      Extract<
        ArticleBody,
        {
          type: Type;
        }
      >,
      'type'
    >
  : never;

export type GetArticleBodyIncludeTypeByType<Type = ArticleBody['type']> = Type extends ArticleBody['type']
  ? Extract<
      ArticleBody,
      {
        type: Type;
      }
    >
  : never;

export interface Article extends Omit<PostEntity, 'body'> {
  body: Array<ArticleBody>;
}

export type ArticleWithSpecificBodyType<Type = ArticleBody['type']> = Omit<Article, 'body'> & {
  body: Array<GetArticleBodyIncludeTypeByType<Type>>;
};
